import { useQuery } from "react-query";
import { getHost } from '../../util/host';
import logo from "../Logo";

const fetchNewsDigest = async () => {
  const host = getHost(true, false);
  const res = await fetch(`${host}/api/v1/news/get_digest`);
  if (!res.ok) throw new Error('Network response was not ok');
  return res.json();
};

const NewsDigest = () => {
  const { data, isLoading, error } = useQuery(['newsDigest'], fetchNewsDigest);

  if (isLoading) {
    return <div>Loading news digest...</div>;
  }

  if (error) {
    return <div>Error loading news digest: {error.message}</div>;
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e0e7ef 0%, #f8fafc 100%)',
      padding: '40px 0',
      boxSizing: 'border-box',
    }}>
      <div style={{
        maxWidth: 768,
        margin: '0 auto',
        padding: 32,
        background: 'rgba(255,255,255,0.92)',
        borderRadius: 24,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        border: '1px solid #c7d6f9',
      }}>
        <div style={{
          color: '#6b7280',
          fontSize: 16,
          marginBottom: 20,
          fontWeight: 500,
          letterSpacing: 0.2,
        }}>
          Week: {`${data?.target_week?.lower} - ${data?.target_week?.upper}`}
        </div>
        <header>
          <h1 style={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo} alt="Logo" style={{ height: 22, verticalAlign: 'middle', marginRight: 12 }} />
            <span style={{ display: 'block', textAlign: 'center' }}>
              Maritime Industry Update – Global Shipbuilding Highlights
            </span>
          </h1>
          <p>Brought By: <a href="https://ella.trusteddocks.com" target="_blank">Ella Trusteddocks</a></p>
        </header>
        <div dangerouslySetInnerHTML={{ __html: data?.content }}>
        </div>
      </div>
    </div>
  );
};

export default NewsDigest;
